import { createStore, applyMiddleware, compose } from "redux";
import createRootReducer from "../reducers/index";
import { createBrowserHistory } from "history";
import { routerMiddleware } from "connected-react-router";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
//import logger from 'redux-logger';
import storage from "redux-persist/lib/storage";
//import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import signalRMiddleware from "../../Middleware/signalRMiddleware";
const persistConfig = {
    key: "root",
    storage,
    blacklist: ['router']
};
export const history: any = createBrowserHistory();
//var reactPlugin = new ReactPlugin();
//var appInsights = new ApplicationInsights({
//    config: {
//        instrumentationKey: 'fe111de2-060a-41ab-8885-7a206f59f9e0',
//        extensions: [reactPlugin],
//        extensionConfig: {
//            [reactPlugin.identifier]: { history: history }
//        }
//    }
//});
//appInsights.loadAppInsights();

const persistedReducer = persistReducer(persistConfig, createRootReducer(history));

function configureStore(preloadedState?: any) {
    const store = createStore(persistedReducer, preloadedState, compose(applyMiddleware(routerMiddleware(history), signalRMiddleware, thunk/*, logger*/)));
    return store;
}

const store: any = configureStore();
export default store;
export const persistor = persistStore(store);